var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRgCheckDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19434 12.5969L6.54209 15.9152L13.5234 7.93656L12.1429 6.73022L6.29092 13.4182L3.30534 11.1394L2.19434 12.5969ZM19.9401 7.93656L18.5596 6.73022L12.7213 13.4026L12.0311 12.8508L10.8853 14.2826L12.945 15.9308L19.9401 7.93656Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgCheckDouble);
export default __webpack_public_path__ + "static/media/rg-check-double.18a15da3bd45257e27fb33baf23b19d5.svg";
export { ForwardRef as ReactComponent };